import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@sb/library/button';
import { SubmissionBarComponent } from './submission-bar.component';

@NgModule({
    declarations: [
        SubmissionBarComponent
    ],
    imports: [
        CommonModule,
        ButtonModule
    ],
    exports: [
        SubmissionBarComponent
    ]
})
export class SubmissionBarModule { }
